import * as React from 'react';
import FontIcon from 'react-md/lib/FontIcons';

import "./DataLoadFailure.scss";

const DataLoadFailure: React.SFC = () => {
    return <div className="data-load-failure">
        <h2>Error loading calculator!</h2>
        <FontIcon>sync_problem</FontIcon>
        <p>Unfortunately the calculator failed to load. Please try again later!</p>
    </div>
}

export default DataLoadFailure;